export default __webpack_public_path__ + "static/media/low_bed_truck.8b8acce2.png";